export const CourseStatus = {
	Active: "active",
	Draft: "draft",
} as const;

export type CourseStatus = (typeof CourseStatus)[keyof typeof CourseStatus];
